export default __webpack_public_path__ + "static/media/1954.2365ccc4.png";